export default {
  possibleId: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789',

  /**
   * Create slug from string
   *
   * @param {string} string
   * @returns {string}
   */
  slugify(string) {
    let slug = '';
    const trimmed = string.trim();
    slug = trimmed.replace(/[^a-z0-9-]/gi, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '');
    return slug.toLowerCase();
  },

  /**
   * Create title from Slug
   *
   * @param {string} slug
   * @returns {string}
   */
  titleFromSlug(slug) {
    const words = slug.split('-');
    return words.map((item) => this.capitalizeFirstLetter(item)).join(' ');
  },

  /**
   * Convert first letter of string to uppercase
   *
   * @param {string} string
   * @returns {string}
   */
  capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  },

  /**
 * Convert spaced string to Title Case
 *
 * @param {string} str
 * @returns {string}
 */
  titleCase(str) {
    const mystr = str.toLowerCase().split(' ');
    return mystr.map((item) => this.capitalizeFirstLetter(item)).join(' ');
  },

  /**
   * Create random 12 character ID
   *
   * @param {number} [length]
   * @returns {string}
   */
  makeid(length = 12) {
    let text = '';
    let i = 0;
    while (i < length) {
      text += this.possibleId.charAt(Math.floor(Math.random() * this.possibleId.length));
      i++;
    }
    return text;
  },

  /**
   * Return XSRF token from cookies
   *
   * @returns {string} token - Empty if no cookie
   */
  getXsrfToken() {
    const cookie = document.cookie.split(';').filter((item) => item.trim().startsWith('XSRF-TOKEN')).shift();
    if (cookie) {
      return decodeURIComponent(cookie.split('=')[1]);
    }
    return '';
  },

  /**
   * Flatten messages
   *
   * @param {string[]} originals
   * @param {string[]} blacklist
   * @returns {string[]}
   */
  flattenMessages(originals, blacklist) {
    let list = [];
    const keys = Object.keys(originals);
    let i = 0;
    while (i < keys.length) {
      if (blacklist.indexOf(keys[i]) === -1) {
        list = list.concat(originals[keys[i]].flat());
      }
      i++;
    }
    return list;
  },
  // https://stackoverflow.com/a/5298684
  removeHash() {
    let scrollV, scrollH, loc = window.location;
    if ("pushState" in history) {
      history.pushState("", document.title, loc.pathname + loc.search);
    } else {
      // Prevent scrolling by storing the page's current scroll offset
      scrollV = document.body.scrollTop;
      scrollH = document.body.scrollLeft;

      loc.hash = "";

      // Restore the scroll offset, should be flicker free
      document.body.scrollTop = scrollV;
      document.body.scrollLeft = scrollH;
    }
  }
};
